
<template>

  <div id="page-user-list">
    <div v-if="activeUserInfo.role == 'doctor'" class="vx-row">

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base px-5 pb-2"
              icon="DollarSignIcon"
              icon-right
              :statistic="totalIncome"
              statisticTitle="Ingresos"
              color="success"
               />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base px-5 pb-2"
              icon="DollarSignIcon"
              icon-right
              :statistic="averageIncome"
              statisticTitle="Ingreso Promedio"
              color="primary" />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base px-5 pb-2"
              icon="BarChart2Icon"
              icon-right
              :statistic="paid"
              statisticTitle="Pagadas"
              color="success" />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base px-5 pb-2"
              icon="ArrowUpIcon"
              icon-right
              :statistic="notPaid"
              statisticTitle="Pendientes"
              color="danger" />
        </div>
        
    </div>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ consultationsList.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : consultationsList.length }} of {{ consultationsList.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <div class="flex-grow">
          <div class="justify-content-right">
            <v-select placeholder="Mes" class="w-5/6" v-model="timeFilter"  :options="['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre' ,'Diciembre']"></v-select>
            </div>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="ml-3 cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Acciones</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            
            <vs-dropdown-menu>


              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Imprimir</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-2 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="consultationsList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="10"
        v-model="currentPage" />

    </div>
    <modal
            name="paymentModal"
            height="auto"
            :scrollable="true"
            style="z-index: 1001;"
          >
            <div class="p-3">
              <div class="vx-row">
                <div class="vx-col w-full" >
                    <vx-card class="my-3" title="Detalles de la consulta">

                        <div class="flex justify-between mb-2">
                            <span>Consulta</span>
                            <span class="font-semibold">
                              <vs-input class="w-full" type="number" min="0" step='0.01' placeholder="" v-model="consultation_total"/>
                            </span>
                        </div>
 
                        <vs-divider />

                        <div class="flex justify-between">
                            <span>Total a pagar</span>
                            <span class="font-semibold">Q{{parseFloat(consultation_total).toFixed(2)}}</span>
                        </div>
                    </vx-card>
                    <vx-card class="mt-3 mb-6" title="Método de Pago">

                        <div class="flex justify-center justify-between mb-2">
                          <v-select class="w-full inline" placeholder="Método de Pago" 
                                      v-model="payment_method" 
                                      :options="['Tarjeta', 'Efectivo', 'Cheque', 'Transferencia']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />   
                        </div>
                        <div class="flex justify-center justify-between mb-2">
                          <vs-checkbox v-if="!factDone" v-model="fel">Generar FEL</vs-checkbox>
                        </div>
                        <div class="py-5 px-3">
                  </div>
                  <div v-if="fel && !factDone">
                    <div class="vx-row mb-2">
              <div class="vx-col md:w-2/5 sm:w-full w-full flex flex-col items-center" >
                <vs-input class="w-full px-5" label="Nombre" placeholder=""
                name="name" v-validate="'required'" v-model='factData.receptor.nombre' />
                <span class="text-danger">{{ errors.first('new-patient.name') }}</span>
              </div>
              <div class="vx-col md:w-2/5 sm:w-full w-full flex flex-col items-center inline">
                <vs-input class="vx-col inline w-full pl-3 mr-3" label="NIT" placeholder=""
                name="nit" v-validate="'required'" v-model='factData.receptor.id_receptor' />
                <span class="text-danger">{{ errors.first('new-patient.nit') }}</span>
              </div>
              <div class="vx-col md:w-1/5 sm:w-full w-full flex flex-col items-center inline">
                <vs-button class="mr-12 mt-6 inline" color="primary" type="filled" 
                 @click="validateNit">
                  Validar
                </vs-button>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Correo Electrónico" placeholder=""
                name="email" v-validate="'required'" v-model='factData.receptor.correo'/>
                <span class="text-danger">{{ errors.first('new-patient.email') }}</span>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Dirección" placeholder=""
                name="direccion" v-validate="'required'" v-model='factData.receptor.direccion'/>
                <span class="text-danger">{{ errors.first('new-patient.direccion') }}</span>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Total de Factura" placeholder=""
                name="total" v-bind:readonly="true" v-validate="'required'" v-model='factData.items[0].precio'/>
                <span class="text-danger">{{ errors.first('new-patient.total') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <v-select class="w-full px-5 mt-6"  placeholder="Motivo" 
                name="motivo" :options='["Servicios Profesionales Médicos", "Otros"]' v-validate="''" v-model='factData.items[0].descripcion'/>
                <span class="text-danger">{{ errors.first('new-patient.motivo') }}</span>
              </div>
            </div>
            <vs-divider class="mt-6 mb-5" />
            <!--<div class="vx-row pt-3 pb-6">
              <div  class="vx-col w-full flex justify-center">
                <vs-button v-if="!factDone"   icon-pack="feather" icon="icon-file-text" class="mr-4" color="primary" type="filled" 
                 @click="generateFact">
                  Generar Factura
                </vs-button>
                <vs-button v-if="factDone"   icon-pack="feather" icon="icon-file-text" class="mr-4" color="primary" type="filled" 
                 @click="openFact(metaFactura.html)">
                  Ver Factura
                </vs-button>
              </div> 
            </div>-->
                  </div>
                  <div class="vx-row pt-3 pb-6">
              <div  class="vx-col w-full flex justify-center">
                    <vs-button v-if="factDone"   icon-pack="feather" icon="icon-file-text" class="mr-4" color="primary" type="filled" 
                 @click="openFact(metaFactura.html)">
                  Ver Factura
                </vs-button>
              </div>
                  </div>
                        <vs-divider class="my-6" />
                        <vs-row v-if="factDone || !fel" vs-w="12" class="mb-4">
                          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                            <vs-button :disabled="!(consultation_total >= 0 && payment_method)" @click="markAsPaid()">Marcar como pagada</vs-button>
                          </vs-col>
                        </vs-row>
                        
                    </vx-card>
                </div>
              </div>
            </div>
          </modal>
  </div>
  

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererRecipe from './cell-renderer/CellRendererRecipe.vue'
import CellRendererExam from './cell-renderer/CellRendererExam.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRendererPatient from './cell-renderer/CellRendererPatient.vue'
import CellRendererPatientSex from './cell-renderer/CellRendererPatientSex.vue'
import CellRendererPatientAge from './cell-renderer/CellRendererPatientAge.vue'
import CellRendererDate from './cell-renderer/CellRendererDate.vue'
import CellRendererClinic from './cell-renderer/CellRendererClinic.vue'
import CellRendererTotal from './cell-renderer/CellRendererTotal.vue'


import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/src/locale'

// statistics card line 
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'



export default {
  components: {
    AgGridVue,
    vSelect,
    Datepicker,
    // Cell Renderer
    CellRendererLink,
    CellRendererRecipe,
    CellRendererExam,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererPatient,
    CellRendererPatientSex,
    CellRendererPatientAge,
    CellRendererDate,
    CellRendererActions,
    StatisticsCardLine,
    CellRendererClinic,
    CellRendererTotal
  },
  data () {
    return {
      fel: false,
      factura: true,
      factDone: false,
      timeFilter: "Sin Filtro",
      timeChange: null,
      filtered: false,
      metaFactura: {
        html: null,
        numeroDocumento: null,
        nombreArchivo: null,
        descripcion: null,
        codigoResultado: null,
      },
      factData: {
        "emisor": {
          "afiliacion": null,
          "cod_establecimiento": 1,
          "cod_postal": "01001",
          "correo": null,
          "departamento": null,
          "municipio": null,
          "direccion": "CIUDAD",
          "nit": null,
          "nombre_com": null,
          "nombre_em": null,
          "pais": null,
          "requestor": null,
          "user": null,
          "username": null,
        },
        "general": {
          "moneda": "GTQ",
          "tipo": "FACT",
          "fecha_hora_emision": null, // toISOString()
        },
        "receptor": {
          "cod_postal": "01001",
          "correo": null,
          "departamento": null,
          "municipio": null,
          "direccion": "CIUDAD",
          "id_receptor": null, // NIT
          "nombre": null,
          "pais": "GT"
          },
        "items": [
        {
            "BoS": "B",
            "cantidad": 1,
            "descripcion": null,
            "descuento": 0,
            "descuentoPorcentual": 0,
            "precio": null,
            "precio_unitario": null,
            "unidad_medida": "UND"
        }
        ]
      }, 
      factDataDef: {
        "emisor": {
          "afiliacion": null,
          "cod_establecimiento": 1,
          "cod_postal": null,
          "correo": null,
          "departamento": null,
          "municipio": null,
          "direccion": null,
          "nit": null,
          "nombre_com": null,
          "nombre_em": null,
          "pais": null,
          "requestor": null,
          "user": null,
          "username": null,
        },
        "general": {
          "moneda": "GTQ",
          "tipo": "FACT",
          "fecha_hora_emision": null, // toISOString()
        },
        "receptor": {
          "cod_postal": "01001",
          "correo": null,
          "departamento": null,
          "municipio": null,
          "direccion": "CIUDAD",
          "id_receptor": "CF", // NIT
          "nombre": "CF",
          "pais": "GT"
          },
        "items": [
        {
            "BoS": "B",
            "cantidad": 1,
            "descripcion": null,
            "descuento": null,
            "descuentoPorcentual": null,
            "precio": null,
            "precio_unitario": null,
            "unidad_medida": "UND"
        }
        ]
      },
      averageIncome: null,
      totalIncome: null,
      paid: null,
      notPaid: null,
      metaFactura: {
        html: null,
        numeroDocumento: null,
        nombreArchivo: null,
      },
      payment_method: null,
      consultation_total: 0,
      curr_consultation_meta: {},
      curr_consultation_id: null,
      loading: true,
      t_height: '100%',
      t_width: '100%',
      // promt
      activePrompt: false,
      // Filter Options
      date1: null,
      langEs: es,
      statusFilter: { label: 'All', value: 'all' },
      statusOptions: [
        { label: 'All', value: 'all' },
        { label: 'Active', value: 'active' },
        { label: 'Deactivated', value: 'deactivated' },
        { label: 'Blocked', value: 'blocked' }
      ],

      isVerifiedFilter: { label: 'All', value: 'all' },
      isVerifiedOptions: [
        { label: 'All', value: 'all' },
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],

      departmentFilter: { label: 'All', value: 'all' },
      departmentOptions: [
        { label: 'Todos', value: 'all' },
        { label: 'Femenino', value: 'F' },
        { label: 'Masculino', value: 'M' },
      ],

      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          filter: false,
          sortable: true,
          resizable: false,
          width: 100
        },
        {
            headerName: 'Paciente',
            field: 'patient',
            getQuickFilterText: function(params) {
                return params.data.patient.first_name+' '+params.data.patient.last_name; 
            },
            sortable: true,
            width: 140,
            cellRendererFramework: 'CellRendererPatient'
        },
        {
            headerName: 'Fecha',
            field: 'date',
            filter: true,
            sortable: true,
            suppressMenu: false,
            minWidth: 215,
            cellRendererFramework: 'CellRendererDate'
        },
        {
            headerName: 'Clinica',
            field: 'clinic',
            filter: true,
            sortable: true,
            width: 200,
            cellRendererFramework: 'CellRendererClinic'
        },
        {
            headerName: 'Estado',
            getQuickFilterText: function(params) {
                return params.data.meta.status; 
            },
            sortable: true,
            width: 180,
            cellRendererFramework: 'CellRendererStatus'
        },
        {
            headerName: 'Total',
            getQuickFilterText: function(params) {
                return params.data.meta.status; 
            },
            sortable: true,
            width: 220,
            cellRendererFramework: 'CellRendererTotal'
        },
        {
            headerName: 'Acciones',
            field: 'transactions',
            sortable: true,
            cellRendererFramework: 'CellRendererActions',
            cellRendererParams: {
              showPaymentModal: this.showPaymentModal,
              test: this.factura,
              width: 220,
          }
        },
        {
        headerName: '',
            field: '',
            filter: false,
            sortable: false,
            width: 250,

        },    
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererRecipe,
        CellRendererExam,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        CellRendererPatient,
        CellRendererDate,
        Datepicker
      }
    }
  },
  watch: {
    roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    isVerifiedFilter (obj) {
      const val = obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
      this.setColumnFilter('is_verified', val)
    },
    departmentFilter (obj) {
      this.setColumnFilter('gender', obj.value)
    }
  },
  computed: {
    consultationsList (){
      console.log(this.timeFilter)
      // return this.$store.state.consultations
      let activeConsultations = this.$store.state.consultations.filter(obj => {
        return ( obj.meta.status && obj.meta.status.toLowerCase() == 'terminada' );
          // || ( obj.meta.status && obj.meta.status.toLowerCase() == 'anulada' );
      });
      activeConsultations.sort(function compare(a, b) {
        var dateA = new Date(a.date);
        var dateB = new Date(b.date);
        return dateA - dateB;
      });
      
      

     if (this.timeFilter != "Sin Filtro") {
       this.filtered = true;
     }
      this.timeChange = {
        "Enero" : '01',
        "Febrero" : '02',
        "Marzo" : '03',
        "Abril" : '04',
        "Mayo" : '05',
        "Junio" : '06',
        "Julio" : '07',
        "Agosto" : '08',
        "Septiembre" : '09',
        "Octubre" : '10',
        "Noviembre" : '11',
        "Diciembre" : '12'
      }
      if (this.timeFilter == null){
        console.log('test')
        this.paid  = activeConsultations.reduce((acc, cur) => cur.meta.paid ? ++acc : acc, 0);
        this.notPaid  = activeConsultations.reduce((acc, cur) => !cur.meta.paid ? ++acc : acc, 0);
        var totalIncome = activeConsultations.reduce((acc, cur) => cur.meta.paid && cur.meta.consultationTotal ? acc+= parseFloat(cur.meta.consultationTotal) : acc, 0);
        var averageIncome  = isFinite(totalIncome/this.paid) ? totalIncome/this.paid : 0;
        this.totalIncome = 'Q '+totalIncome.toFixed(2);
        this.averageIncome = 'Q '+averageIncome.toFixed(2);
        return activeConsultations.reverse();
      }
       else if (this.filtered) {
        activeConsultations = activeConsultations.reverse().filter(consultation => consultation.date.slice(5, 7) == this.timeChange[this.timeFilter]);
        this.paid  = activeConsultations.reduce((acc, cur) => cur.meta.paid ? ++acc : acc, 0);
        this.notPaid  = activeConsultations.reduce((acc, cur) => !cur.meta.paid ? ++acc : acc, 0);
        var totalIncome = activeConsultations.reduce((acc, cur) => cur.meta.paid && cur.meta.consultationTotal ? acc+= parseFloat(cur.meta.consultationTotal) : acc, 0);
        var averageIncome  = isFinite(totalIncome/this.paid) ? totalIncome/this.paid : 0;
        this.totalIncome = 'Q '+totalIncome.toFixed(2);
        this.averageIncome = 'Q '+averageIncome.toFixed(2);
        return activeConsultations;
      } else {
        this.paid  = activeConsultations.reduce((acc, cur) => cur.meta.paid ? ++acc : acc, 0);
        this.notPaid  = activeConsultations.reduce((acc, cur) => !cur.meta.paid ? ++acc : acc, 0);
        var totalIncome = activeConsultations.reduce((acc, cur) => cur.meta.paid && cur.meta.consultationTotal ? acc+= parseFloat(cur.meta.consultationTotal) : acc, 0);
        var averageIncome  = isFinite(totalIncome/this.paid) ? totalIncome/this.paid : 0;
        this.totalIncome = 'Q '+totalIncome.toFixed(2);
        this.averageIncome = 'Q '+averageIncome.toFixed(2);
        return activeConsultations.reverse();
      }
      
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    openFact(html) {
      var win = window.open("", "_blank",);
      win.document.body.innerHTML = html
    },
    before2012() {
      var dateFilterComponent = this.gridApi.getFilterInstance('date');
      dateFilterComponent.setModel({
        type: 'contains',
        dateFrom: '2021',
        dateTo: null,
      });
      this.gridApi.onFilterChanged();
    },
    validateNit() {
      this.$store.dispatch('validateNit', this.factData.receptor.id_receptor).then(response=>{
         this.factData.receptor.nombre = response.data.nombre.nombreCompletoRegistrado
         this.showAlert(
            "success",
            "Nit Validado",
            ("Nombre Registrado: " + response.data.nombre.nombreCompletoRegistrado) 
          );
      }, error => {
        console.log (error)
        this.showAlert(
          "warning",
          "Error al validar NIT",
          "Porfavor revisar el NIT"
        )

      });
    },

    generateFact () {
      var factDate = new Date()
      this.factData.emisor.nombre_em = this.activeUserInfo.meta.datosFacturacion.empresarial
      this.factData.emisor.nombre_com = this.activeUserInfo.meta.datosFacturacion.empresarial
      this.factData.emisor.afiliacion = this.activeUserInfo.meta.datosFacturacion.afiliacion
      this.factData.emisor.pais = this.activeUserInfo.meta.datosFacturacion.pais
      this.factData.emisor.correo = this.activeUserInfo.meta.datosFacturacion.email
      this.factData.emisor.username = this.activeUserInfo.meta.datosFacturacion.username
      this.factData.emisor.requestor = this.activeUserInfo.meta.datosFacturacion.requestor
      this.factData.emisor.user = this.activeUserInfo.meta.datosFacturacion.user
      this.factData.emisor.nit = this.activeUserInfo.meta.datosFacturacion.nit
      this.factData.emisor.municipio = "Guatemala"
      this.factData.emisor.departamento = "Guatemala"
      this.factData.items[0].precio_unitario = this.factData.items[0].precio
      this.factData.receptor.fecha_hora_emision = factDate.toISOString();
      this.$store.dispatch('generateReceipt', this.factData).then((response2) => { 
          this.facturado = true;
          this.metaFactura.html = response2.data.emailhtmlTemplate;
          this.metaFactura.numeroDocumento = response2.data.numeroDocumento;
          this.metaFactura.nombreArchivo = response2.data.nombreArchivo;
          this.metaFactura.descripcion = response2.data.descripcion;
          this.metaFactura.codigoResultado = response2.data.codigoResultado;
          this.showAlert('success', 'Factura Generada Exitosamente', )
      });
    this.factDone = true;
    },
    showAlert (color,title,text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text
      })
    },
    markAsPaid(){
      var payload = new Object();
      payload.meta = {...this.curr_consultation_meta, ...{paid: true, consultationTotal: this.consultation_total, paymentMethod: this.payment_method}, ...this.metaFactura}
      payload.event_id = this.curr_consultation_id;
      this.$store.dispatch('editEvent',payload).then(response => {
        
        console.log('RESPONSE!: ',response);
        this.showAlert('success','Consulta Pagada','Consulta marcada como pagada de manera exitosa!');
        // this.$store.dispatch('notifyFinishSuccess', response).then((response2) => { 
        //   setTimeout(() => {
        //     window.location.href = '/consultations/upcommingAppointments';
        //   }, 1500);         
        // }).catch(function (error) {
        //     console.log(error);
        // });
        this.curr_consultation_meta = {},
        this.curr_consultation_id = null

        this.$modal.hide('paymentModal');
      }, error => {
        console.error(error);
        this.showAlert('danger','Error al terminar consulta',error.response.data.error);

      });
    },
    showPaymentModal(data){
      console.log(data);
      this.consultation_total = data.meta.consultationTotal ? data.meta.consultationTotal : 0.00;
      this.factData.items[0].precio = data.meta.consultationTotal ? data.meta.consultationTotal : 0.00;
      this.curr_consultation_meta = data.meta;
      this.curr_consultation_id = data.id;
      this.factData.receptor.correo = data.patient.email
      this.$modal.show('paymentModal');
    },

    calculateAge(dob){
        var birth_year = dob.substring(0,4),
        birth_month = dob.substring(5,7),
        birth_day = dob.substring(8,10);
        
        var today_date = new Date(),
        today_year = today_date.getFullYear(),
        today_month = today_date.getMonth(),
        today_day = today_date.getDate(),
        age = today_year - birth_year;

        if ( today_month < (birth_month - 1))
        {
            age--;
        }
        if (((birth_month - 1) == today_month) && (today_day < birth_day))
        {
            age--;
        }
        return age;
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted () {
    this.$store.dispatch('fetchEvents');

    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
